import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorType, initialDataLoadState, type DataLoadState } from '../../../store/reducers/common';

const initialState: DataLoadState = {
  ...initialDataLoadState,
};

const slice = createSlice({
  name: 'start-or-resume-application',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    startOrResumeApplication: (state, _action: PayloadAction<{ fleetId: string } | undefined>) => ({
      ...state,
      loading: true,
      error: null,
    }),
    startOrResumeApplicationFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
    }),
    startOrResumeApplicationSuccess: (state) => ({
      ...state,
      loading: false,
      error: null,
    }),
  },
});

export const startOrResumeApplicationReducer = slice.reducer;
export const { startOrResumeApplication, startOrResumeApplicationFail, startOrResumeApplicationSuccess } =
  slice.actions;
